import React from "react";
import PropTypes from "prop-types";
import useCollections from "../../query/useCollections";
import InfiniteScroll from "../../component/infiniteScroll/InfiniteScroll";
import CollectionCard from "./components/CollectionCard";
import "./Collections.css";
import { collectionsUrl, webappURL } from "../../util/url";
import { Helmet } from "react-helmet-async";
import { collectionsPageSchemaOrg, safeJsonLd } from "../../util/schemaOrg";

const PRIORITY_CARD_COUNT = 3;

/**
 * Collections 페이지 컴포넌트
 * 컬렉션 목록을 무한 스크롤로 표시합니다.
 */
export default function Collections({ hostname }) {
  const { loading, collections, loadMore, hasMore } = useCollections();
  
  const metaTitle = "기획전 모아보기 | 후루츠패밀리 - 빈티지, 세컨핸드 패션 중고거래";
  const metaDescription = "트렌디한 아이템부터 숨은 취향템까지, 후루츠패밀리가 매주 큐레이팅한 기획전을 한눈에 만나보세요. 빈티지, 프리미엄 세컨핸드 패션부터 감도 높은 악세사리까지—당신의 취향을 자극할 컬렉션이 기다리고 있어요.";
  const metaUrl = webappURL(hostname) + collectionsUrl();

  return (
    <section className="Collections container">
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <link rel="canonical" href={metaUrl} />
        <meta property="og:title" content="기획전 모아보기 | 후루츠패밀리" />
        <meta property="og:description" content="트렌디한 아이템부터 숨은 취향템까지, 후루츠패밀리가 매주 큐레이팅한 기획전을 한눈에 만나보세요." />
        <meta property="og:image" content={`${webappURL(hostname)}/logo512.png`} />
        <meta property="og:url" content={metaUrl} />
        <script type="application/ld+json">
          {safeJsonLd(collectionsPageSchemaOrg(collections, webappURL(hostname)))}
        </script>
      </Helmet>
      <div className="Collections-header">
        <h1 className="Collections-title">Curated Collections</h1>
        <p className="Collections-subtitle">
          후루츠패밀리가 엄선한 특별한 컬렉션을 만나보세요
        </p>
      </div>

      <InfiniteScroll loading={loading} hasMore={hasMore} loadMore={loadMore}>
        <ul className="Collections-grid">
          {collections.map((collection, index) => (
            <CollectionCard
              key={collection.id}
              collection={collection}
              priority={index < PRIORITY_CARD_COUNT}
            />
          ))}
        </ul>
      </InfiniteScroll>
    </section>
  );
}

Collections.propTypes = {
  hostname: PropTypes.string.isRequired,
};
